import axios from 'axios';

import { NutriScoreCategory } from 'enums/nutriScoreCategory';
import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/BaseIngredientCategory/${id}`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ParentCategory = {
	id: string;
	name: string;
};

export type ResponseData = {
	id: string;
	nameTranslations: {
		[key: string]: string;
	};
	parent: ParentCategory | null;
	nutriScoreCategory: NutriScoreCategory;
};

export const defaultResponseData = (): ResponseData => {
	return {
		id: '',
		nameTranslations: {},
		parent: null,
		nutriScoreCategory: NutriScoreCategory.StandardFood,
	};
};
